module.exports = __webpack_public_path__ + "meteorshower2.409845f81e36c98cb521.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/images/meteorshower2.jpg
// module id = 813
// module chunks = 3